import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable, DataTableFilterMeta } from 'primereact/datatable';
import { SplitButton } from 'primereact/splitbutton';
import { Toolbar } from 'primereact/toolbar';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import tenantService from './tenant-service';
import { InputText } from 'primereact/inputtext';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import BreadcrumbComponent from '../../../components/Breadcrumb';

const defaultFilters: DataTableFilterMeta = {
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    name: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    'fullName': {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    representative: { value: null, matchMode: FilterMatchMode.IN },
    date: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
    },
    balance: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
    },
    status: {
        operator: FilterOperator.OR,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
    },
    activity: { value: null, matchMode: FilterMatchMode.BETWEEN },
    verified: { value: null, matchMode: FilterMatchMode.EQUALS },
};


const TenantList: React.FC = () => {

    const [clientState, setClientState] = useState<any>(null);
    const [tenant, setTenants] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [filters, setFilters] = useState<DataTableFilterMeta>(defaultFilters);
    const [globalFilterValue, setGlobalFilterValue] = useState<string>('');
    const navigate = useNavigate();

    const formatDate = (rowData: any) => {
        const date = new Date(rowData.insertDate);
        return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', }); // Example: dd/mm/yyyy
    };


    useEffect(() => {
        const fetchClientState = async () => {
            try {
                const clientStateItem = await tenantService.getClientState();
                setClientState(clientStateItem);
            } catch (error) {
                console.error('Error fetching client state:', error);
            }
        };

        fetchClientState();
    }, [])

    useEffect(() => {
        if (clientState) {
            const fetchTenantList = async () => {
                try {
                    const response = await tenantService.findAllTenant();
                    setTenants(response); 
                } catch (error) {
                    console.error('Error fetching user data:', error);
                } finally {
                    setLoading(false);
                }
            };

            fetchTenantList();
        }
    }, [clientState]);

    const onGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        let _filters = { ...filters };

        // @ts-ignore
        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    function handleCreate(): void {
        navigate(`/admin/tenant-edit`);
    }

    function handleEdit(data: any): void {
        navigate(`/admin/tenant-edit`, { state: { tenant: data } });
    }

    function handleView(data: any): void {
        navigate(`/admin/tenant-view`, { state: { tenant: data } });
    }

    function handlePrint(): void {
        window.print();
    };

    const header = () => {
        return (
            <div className="flex justify-content-between">
                {/* <Button type="button" icon="pi pi-filter-slash" label="Clear" outlined onClick={clearFilter} /> */}
                <div>
                    {/* <InputIcon className="pi pi-search" /> */}
                    <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" />
                </div>
                <div>
                    <Button icon="pi pi-print" severity="danger" style={{ marginRight: '.1em' }} onClick={() => handlePrint()} />
                    {/* <Button label="New" icon="pi pi-plus" style={{ marginRight: '.5em' }} onClick={() => handleCreate()} /> */}
                </div>
            </div>
        );
    };

    const actionTemplate = (rowData: any) => (
        <div style={{ display: 'flex', gap: '5px' }}>
            <Button
                label="View"
                icon="pi pi-eye"
                className="p-button-info p-button-sm "
                style={{ padding: '5px 5px', fontSize: '10px' }}
                onClick={() => handleView(rowData)}
            />
            <Button
                label="Edit"
                icon="pi pi-pencil"
                className="p-button-warning p-button-sm "
                style={{ padding: '5px 5px', fontSize: '10px' }}
                onClick={() => handleEdit(rowData)}
            />
        </div>
    );

    return (
        <div className='grid'>
            <div className='col-12'>
                <div className='card-title'>
                    <h5>Facility Profile</h5>
                    <BreadcrumbComponent />
                </div>
                <div className='card'>
                    <>
                        <div>
                            <DataTable value={tenant} showGridlines scrollable scrollHeight="350px" paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]}
                                filters={filters} globalFilterFields={['fullName', 'facilityCode', 'recordStatus', 'addressEnglish']}
                                sortField='modifiedDate' sortOrder={-1} loading={loading} header={header}>
                                <Column
                                    header="No."
                                    style={{ width: '5%' }}
                                    body={(_, { rowIndex }) => rowIndex + 1} // Render row number
                                >
                                </Column>
                                <Column
                                    header="Register Date"
                                    body={formatDate}
                                >
                                </Column>
                                <Column
                                    header="Facility Name" field='fullName'>
                                </Column>
                                <Column
                                    header="Facility ID" field='facilityCode'>
                                </Column>

                                <Column
                                    header="Address"
                                    body={(rowData) => `${rowData.address}, ${rowData.city}, ${rowData.postcode}`}>
                                </Column>
                                <Column
                                    header="Status"
                                    body={(rowData) => (rowData.recordStatus === "1" ? "Active" : "Inactive")}
                                >
                                </Column>
                                <Column body={actionTemplate} header="Actions" style={{ width: '20%' }} >
                                </Column>

                            </DataTable>
                        </div>

                    </>



                </div>
            </div>
        </div>
    );
};

export default TenantList;